import { getLinkType } from '../helpers';
import { LinkType } from '../../constants';

const modifyLinks = (fieldElement: HTMLElement): void => {
	const links = [...fieldElement.querySelectorAll('a')];

	links.forEach((link) => {
		const { href, dataset: { action = '' } } = link;
		const isGotoPageLink = getLinkType(href) === LinkType.gotoPage;

		if (isGotoPageLink) {
			link.setAttribute('onclick', action);
			link.setAttribute('ontouchend', action);
			link.removeAttribute('data-action');
		}
	});
};

const modifySpanInnerHtml = (spans: HTMLSpanElement[], innerText: string): void => {
	const { style, className } = spans.reduce((acc, { attributes, className }) => {
		if (attributes['style']) { // tslint:disable-line no-string-literal
			acc.style += `${attributes['style'].value};`; // tslint:disable-line no-string-literal
		}
		if (className) {
			acc.className += `${className} `;
		}
		return acc;
	}, { style: '', className: '' });

	const span = spans[0];
	span.setAttribute('style', style);
	span.className = className.trim();
	span.innerHTML = innerText;
};

// Transform set of Slate marks (several spans one inside another, each with one inline style) to only one span with all styles
export const modifyElementContent = (fieldElement: HTMLElement, modificationFunction: (fieldElement: HTMLElement) => void): void => {
	modificationFunction(fieldElement);
	modifyLinks(fieldElement);

	const firstSpans = [...fieldElement.querySelectorAll(':not(span) > span')];

	firstSpans.forEach((firstSpan: HTMLSpanElement) => {
		const parentNode = firstSpan.closest('p, a');
		const { innerText } = firstSpan;

		// remove unnecessary Slate service empty marks
		if (!innerText && parentNode) {
			return parentNode.removeChild(firstSpan);
		}

		const allSpans = [firstSpan, ...firstSpan.querySelectorAll('span')];
		return modifySpanInnerHtml(allSpans, innerText);
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/editableTextFields/saveData.ts